var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.OzBaseButton,{class:[
    // SIZE & SHAPE
    // Common styles
    // Remove the default focus ring
    'focus-visible:outline-none',

    // Reset user agent styles
    // Don't set px-0 here so we won't have specificity issues
    'py-0',

    // Centralize button content
    'flex',
    'items-center',
    'justify-center',

    // Presets
    _vm.sizePreset === _setup.SizePreset.H40px && [
      'h-10',
      'px-3.5',
      'rounded-[5px]',
      'focus-visible:ring-[2.5px]',

      // Skew the button along the X axis
      {
        'skew-x-[10deg]': _vm.dir === 'ltr',
        'skew-x-[-10deg]': _vm.dir === 'rtl',
        'skew-x-[10deg] rtl:skew-x-[-10deg]': _vm.dir === 'auto',
      },
    ],

    // COLOR SCHEMES
    // Focus ring
    {
      'ring-grape-500': _vm.darkMode === false,
      'ring-canary-500': _vm.darkMode === true,
      'ring-grape-500 dark:ring-canary-500': _vm.darkMode === 'auto',
    },

    // Background
    {
      'active:!bg-grape-500': _vm.darkMode === false,
      'active:!bg-canary-500': _vm.darkMode === true,
      'active:!bg-grape-500 dark:active:!bg-canary-500': _vm.darkMode === 'auto',
    },

    // Text
    {
      'text-dark-text-200 active:text-light-text-200': _vm.darkMode === false,
      'text-light-text-200 active:text-dark-text-200': _vm.darkMode === true,
      'text-dark-text-200 dark:text-light-text-200 active:text-light-text-200 dark:active:text-dark-text-200':
        _vm.darkMode === 'auto',
    },
  ],attrs:{"aria-label":_vm.ariaLabel,"dir":_vm.dir,"disabled":_vm.disabled,"href":_vm.href,"href-mode":_vm.hrefMode},on:{"focus":function($event){return _vm.$emit('focus', $event)},"blur":function($event){return _vm.$emit('blur', $event)},"mouseenter":function($event){return _vm.$emit('mouseenter', $event)},"mouseleave":function($event){return _vm.$emit('mouseleave', $event)},"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{class:[
      'flex',
      'items-center',
      'justify-center',

      // Unskew the content on the X axis
      {
        'skew-x-[-10deg]': _vm.dir === 'ltr',
        'skew-x-[10deg]': _vm.dir === 'rtl',
        'skew-x-[-10deg] rtl:skew-x-[10deg]': _vm.dir === 'auto',
      },
    ]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }